import { type FC } from "react";
import { SquareArrowOutUpRight } from "lucide-react";
import { getRepoUrl } from "@/repo-url";
import { SkeletonText } from "@/components/podkit/loading/Skeleton";
import { type PlainEnvironment } from "@/queries/environment-queries";
import { useListRunnerSCMIntegrations } from "@/queries/runner-configuration-queries";
import { SourceControlProviderIcon } from "@/components/runners/details/SourceControlProviderIcon";

export const Repository: FC<{ failed: boolean; environment?: PlainEnvironment; showRepoUrlLink?: boolean }> = ({
    failed,
    environment,
    showRepoUrlLink = true,
}) => {
    const parsed = environment && getRepoUrl(environment);

    const { data: integrations } = useListRunnerSCMIntegrations(environment?.metadata?.runnerId);
    const scmId =
        parsed?.repoUrl && integrations
            ? integrations.find((integration) => new URL(parsed.repoUrl).host === integration.host)?.scmId
            : undefined;

    return (
        <div className="flex min-h-5 flex-row items-center justify-start gap-2 text-lg font-bold">
            <SkeletonText size="lg" className="w-40" failed={failed} ready={Boolean(environment)} hideOnFailed={true}>
                <SourceControlProviderIcon scmId={scmId} className="inline-block" size="base" />
                <div>{parsed ? `${parsed.account}/${parsed.repo}` : "From scratch"}</div>
                {showRepoUrlLink && parsed?.repoUrl && (
                    <a href={parsed.repoUrl} target="_blank" rel="noreferrer">
                        <SquareArrowOutUpRight size={14} className="text-content-secondary" />
                    </a>
                )}
            </SkeletonText>
        </div>
    );
};
